import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getMenuSet, IMenuSetResponseBody } from 'src/api/getMenuSet';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from '../QueryKeys';

/**
 * Hook for fetching a single menu set, including each of its menus' sections and items.
 */
export const useMenuSet = (
  menuSetId?: string,
  options?: UseQueryOptions<IMenuSetResponseBody>,
): UseQueryResult<IMenuSetResponseBody> => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();

  return useQuery<IMenuSetResponseBody>({
    queryKey: [QueryKeys.menuSet, getBrandId(), menuSetId],
    queryFn: async () => getMenuSet(menuSetId),
    enabled: !!menuSetId,
    onError: (error) => {
      console.error('Error fetching menu set:', error);
      captureException(error, { tags: { action: 'fetch_menu_set', menuSetId } });
      showSnackbar({ status: SnackbarStatus.ERROR, message: 'Something went wrong whilst fetching the menu set' });
    },
    ...options,
  });
};
